import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import RolePermissionsList from "./rolePermissionsList";
import { fetchRolePermissionsList } from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";

const RolePermissions = ({ navigate }) => {
  const [rolePermissions, setRolePermissions] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const res = await fetchRolePermissionsList();
      if (res?.data?.success && res?.data?.data) {
        setRolePermissions(res.data.data);
      } else {
        handleErrors(res, navigate);
      }
    };
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>System Settings</a>
                  </li>
                  <li className="breadcrumb-item active text-light">
                    Role Base Permission
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <RolePermissionsList
          rolePermissions={rolePermissions}
          setRolePermissions={setRolePermissions}
        />
      </div>
    </DashboardLayout>
  );
};
export default RolePermissions;
